<app-page-section sectionClass="hero" containerClass="container">
  <div class="row align-items-center g-5">
    <div class="col-lg-6">
      <span class="badge rounded-pill text-bg-primary mb-3">{{ i18n.t('home.badge') }}</span>
      <h1 class="display-4 fw-bold lh-1 mb-4">{{ i18n.t('home.titleBefore') }} <span class="text-gradient">{{ i18n.t('home.titleHighlight') }}</span>{{ i18n.t('home.titleAfter') }}</h1>
      <p class="lead text-secondary mb-4">{{ i18n.t('home.subtitle') }}</p>
      @if (!session.isLoggedIn()) {
        <div class="d-flex flex-column flex-sm-row gap-3 hero-actions">
          <a routerLink="/login" class="btn btn-primary btn-lg px-4"><i class="bi bi-box-arrow-in-right me-2"></i>{{ i18n.t('common.login') }}</a>
          <a routerLink="/signup" class="btn btn-outline-primary btn-lg px-4"><i class="bi bi-person-plus me-2"></i>{{ i18n.t('common.signup') }}</a>
        </div>
      } @else {
        <a routerLink="/dashboard" class="btn btn-primary btn-lg px-4"><i class="bi bi-speedometer2 me-2"></i>{{ i18n.t('common.dashboard') }}</a>
      }
    </div>

    <div class="col-lg-6">
      <div class="hero-card bg-white p-4 p-md-5">
        <div class="d-flex align-items-center justify-content-between mb-4 hero-card-heading">
          <div>
            <p class="text-secondary mb-1">{{ i18n.t('home.readiness') }}</p>
            <h2 class="h4 mb-0">{{ session.isLoggedIn() ? i18n.t('home.readinessScore', { score: readinessScore }) : i18n.t('home.readinessStart') }}</h2>
          </div>
          <i class="bi bi-mortarboard-fill fs-1 text-primary"></i>
        </div>
        <div class="progress mb-3" style="height:10px"><div class="progress-bar" [style.width.%]="readinessBarWidth"></div></div>
        @if (session.isLoggedIn()) {
          <div class="completion-steps mb-4">
            <button class="completion-steps-toggle" type="button" (click)="toggleCompletionSteps()" [attr.aria-expanded]="isCompletionStepsOpen">
              <span><i class="bi bi-list-check me-2"></i>{{ i18n.t('home.completionSteps.title') }}</span>
              <span class="completion-steps-summary">
                {{ i18n.t('home.completionSteps.summaryCount', { completed: profileCompletion.completedCount(), total: profileCompletion.items().length }) }}
                <i class="bi" [class.bi-chevron-down]="!isCompletionStepsOpen" [class.bi-chevron-up]="isCompletionStepsOpen"></i>
              </span>
            </button>
            @if (isCompletionStepsOpen) {
              <div class="completion-steps-list">
                @for (item of profileCompletion.items(); track item.key) {
                  <a class="completion-step-link" [routerLink]="item.route">
                    <span class="completion-step-status" [class.is-complete]="item.completed">
                      <i class="bi" [class.bi-check-circle-fill]="item.completed" [class.bi-circle]="!item.completed"></i>
                    </span>
                    <span>{{ i18n.t(item.labelKey) }}</span>
                    <i class="bi bi-chevron-right ms-auto text-secondary"></i>
                  </a>
                }
              </div>
            }
          </div>
        }
        <div class="row g-3">
          <div class="col-6"><div class="p-3 rounded-4 bg-light"><strong>{{ session.isLoggedIn() ? i18n.t('home.dashboardReady') : i18n.t('home.afterSignup') }}</strong><br><small class="text-secondary">{{ i18n.t('home.matchingOffers') }}</small></div></div>
          <div class="col-6"><div class="p-3 rounded-4 bg-light"><strong>{{ session.isLoggedIn() ? i18n.t('home.filesReady') : i18n.t('home.afterProfile') }}</strong><br><small class="text-secondary">{{ i18n.t('home.savedDeadlines') }}</small></div></div>
          <div class="col-12"><div class="p-3 rounded-4 bg-primary-subtle"><i class="bi bi-stars me-2"></i>{{ i18n.t('home.aiAssist') }}</div></div>
        </div>
      </div>
    </div>
  </div>
</app-page-section>

<app-page-section sectionClass="section-pad" containerClass="container" [withOffset]="false">
  <div class="row g-4">
    <div class="col-md-4"><div class="soft-card bg-white h-100 p-4"><i class="bi bi-search fs-2 text-primary"></i><h3 class="h5 mt-3">{{ i18n.t('home.discoverTitle') }}</h3><p class="text-secondary">{{ i18n.t('home.discoverText') }}</p></div></div>
    <div class="col-md-4"><div class="soft-card bg-white h-100 p-4"><i class="bi bi-kanban fs-2 text-primary"></i><h3 class="h5 mt-3">{{ i18n.t('home.organizeTitle') }}</h3><p class="text-secondary">{{ i18n.t('home.organizeText') }}</p></div></div>
    <div class="col-md-4"><div class="soft-card bg-white h-100 p-4"><i class="bi bi-shield-check fs-2 text-primary"></i><h3 class="h5 mt-3">{{ i18n.t('home.applyTitle') }}</h3><p class="text-secondary">{{ i18n.t('home.applyText') }}</p></div></div>
  </div>
</app-page-section>
